import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapConstants } from '@gisatcz/ptr-core';
import { map as mapUtils } from '@gisatcz/ptr-utils';

// TODO add tests
/**
 * Return boxRange from zoom level and dimensions
 * @param level {number} Zoom level as decimal number
 * @param width {number} width of viewport in px
 * @param height {number} height of viewport in px
 * @returns {number} Panther's mapView.boxRange in meters
 */
function getBoxRangeFromZoomLevel(level, width, height) {
  level += 1; // TODO add 1 to meet the same view in Deck as in Leaflet
  var lowerLevel = Math.floor(level);
  var upperLevel = Math.ceil(level);
  var lowerPxSize = mapUtils.view.getPixelSizeFromZoomLevel(lowerLevel);
  var upperPxSize = mapUtils.view.getPixelSizeFromZoomLevel(upperLevel);
  var pxSize = (lowerPxSize - upperPxSize) * (upperLevel - level) + upperPxSize;
  return mapUtils.view.getMapViewportRange(width, height) * pxSize;
}

/**
 * Return zoom level from boxRange and dimensions
 * @param boxRange {number} Panther's mapView.boxRange in meters
 * @param width {number} width of viewport in px
 * @param height {number} height of viewport in px
 * @returns {number} Zoom level as decimal number
 */
function getZoomLevelFromBoxRange(boxRange, width, height) {
  return getZoomLevelFromPixelSize((boxRange - 1) / mapUtils.view.getMapViewportRange(width, height));
}

/**
 * Return zoom level (decimal number)
 * @param pxSize {number} Size of 1px in meters
 * @returns {number} Zoom level
 */
function getZoomLevelFromPixelSize(pxSize) {
  var levels = mapConstants.pixelSizeInLevels;
  var lowerLevel = 0;
  while (pxSize <= levels[lowerLevel + 1] && lowerLevel < levels.length) {
    lowerLevel++;
  }
  var upperLevel = lowerLevel + 1;
  var lowerLevelPxSize = levels[lowerLevel];
  var upperLevelPxSize = levels[upperLevel];
  if (upperLevel >= levels.length) {
    return lowerLevel;
  } else {
    var level = upperLevel - (pxSize - upperLevelPxSize) / (lowerLevelPxSize - upperLevelPxSize);
    level -= 1; // TODO remove 1 to meet the same view in Deck as in Leaflet

    return level >= 0 ? level : 0;
  }
}

/**
 * Return DeckGl map view state representation
 * @param view {Object} Panther's map view representation
 * @param width {number} width of viewport in px
 * @param height {number} height of viewport in px
 * @param viewLimits {Object} Panther's map view limits representation
 * @returns {{maxZoom: number, latitude: number, minZoom: number, zoom: number, longitude: number}}
 */
function getDeckViewFromPantherViewParams(view, width, height, viewLimits) {
  var completeView = _objectSpread(_objectSpread({}, mapConstants.defaultMapView), view);
  var minZoom = mapConstants.defaultLevelsRange[0];
  var maxZoom = mapConstants.defaultLevelsRange[1];
  if (viewLimits !== null && viewLimits !== void 0 && viewLimits.boxRangeRange) {
    if (viewLimits.boxRangeRange[1]) {
      var calculatedMinZoom = getZoomLevelFromBoxRange(viewLimits.boxRangeRange[1], width, height);
      if (calculatedMinZoom > minZoom) {
        minZoom = calculatedMinZoom;
      }
    }
    if (viewLimits.boxRangeRange[0]) {
      var calculatedMaxZoom = getZoomLevelFromBoxRange(viewLimits.boxRangeRange[0], width, height);
      if (calculatedMaxZoom < maxZoom) {
        maxZoom = calculatedMaxZoom;
      }
    }
  }
  return _objectSpread({
    latitude: completeView.center.lat,
    longitude: completeView.center.lon,
    zoom: getZoomLevelFromBoxRange(completeView.boxRange, width, height),
    minZoom: minZoom,
    maxZoom: maxZoom,
    pitch: completeView.pitch,
    bearing: completeView.bearing
  }, completeView.deckGlTransitionProperties ? _objectSpread({}, completeView.deckGlTransitionProperties) : {});
}
export default {
  getBoxRangeFromZoomLevel: getBoxRangeFromZoomLevel,
  getZoomLevelFromBoxRange: getZoomLevelFromBoxRange,
  getZoomLevelFromPixelSize: getZoomLevelFromPixelSize,
  getDeckViewFromPantherViewParams: getDeckViewFromPantherViewParams
};